export class SourceConvert {
    constructor() {}

    static toHumanRead(source, plural) {
        const sources = {
            accounting: "Contábil",
            financial: "Financeiro",
            tax: "Fiscal",
            personnel: "Pessoal",
            custom: "custom",
            contabil: "Contábil",
            financeiro: "Financeiro",
            pessoal: "Pessoal",
            fiscal: "Fiscal",
            fin: "Financeiro",
            simplesNacional: "PGDAS",
            eSocial: "eSocial"
        };

        const sourcesPlural = {
            accounting: "Contábeis",
            financial: "Financeiros",
            tax: "Fiscais",
            personnel: "Pessoais",
            custom: "custom",
            contabil: "Contábeis",
            financeiro: "Financeiros",
            pessoal: "Pessoais",
            fiscal: "Fiscais",
            fin: "Financeiros"
        };

        if (plural) return sourcesPlural[source];
        return sources[source];
    }

    static toHuman(source) {
        if (source) source = source.toLowerCase();

        const sources = {
            accounting: "contabil",
            // financial: "financeiro",
            tax: "fiscal",
            simplesnacional: "PGDAS",
            personnel: "pessoal",
            custom: "custom",
            contabil: "contabil",
            financeiro: "financeiro",
            contábil: "contabil",
            fiscal: "fiscal",
            pessoal: "pessoal",
            fin: "financeiro",
            financial: "financeiro",
            esocial: "eSocial"
        };

        return sources[source];
    }

    static toSystem(source) {
        if (source) source = source.toLowerCase();

        const sources = {
            contábil: "accounting",
            contabil: "accounting",
            // financeiro: "financial",
            fiscal: "tax",
            pgdas: "simplesNacional",
            tax: "tax",
            personnel: "personnel",
            pessoal: "personnel",
            accounting: "accounting",
            financial: "financial",
            custom: "custom",
            financeiro: "fin",
            fin: "fin",
            simplesnacional: "simplesNacional",
            esocial: "eSocial",
            eSocial: "eSocial"
        };

        return sources[source];
    }
}
